// ui/export/visitasExport.js  (Excel de las filas visibles; misma técnica que cuentas-list-export.js)
import xlsx from 'json-as-xlsx';

const VisitasExport = (rows, cicloNombre = '') => {
  const xlsData = [
    {
      sheet: 'Visitas',
      columns: [
        { label: 'FECHA', value: 'fecha' },
        { label: 'MOTIVO', value: 'motivo' },
        { label: 'PRODUCTOR', value: 'productor_nombre' },
        { label: 'PARCELA', value: 'parcela_nombre' },
        { label: 'RESPONSABLE', value: 'responsable_nombre' },
      ],
      content: rows,
    },
  ];
  xlsx(xlsData, { fileName: `visitas_${cicloNombre}` });
};

export default VisitasExport;
